function index() {
  return import(/* webpackChunkName: "page-index" */ '@/pages/index.vue')
}
function _404() {
  return import(/* webpackChunkName: "page-404" */ '@/pages/404.vue')
}
function create_account() {
  return import(
    /* webpackChunkName: "page-create-account" */ '@/pages/create-account.vue'
  )
}
function login() {
  return import(/* webpackChunkName: "page-login" */ '@/pages/login.vue')
}
function new_password() {
  return import(
    /* webpackChunkName: "page-new-password" */ '@/pages/new-password.vue'
  )
}
function reset_password() {
  return import(
    /* webpackChunkName: "page-reset-password" */ '@/pages/reset-password.vue'
  )
}
function setup_profile() {
  return import(
    /* webpackChunkName: "page-setup-profile" */ '@/pages/setup-profile.vue'
  )
}
function simulator_remote() {
  return import(
    /* webpackChunkName: "page-simulator-remote" */ '@/pages/simulator-remote.vue'
  )
}
function about_index() {
  return import(
    /* webpackChunkName: "page-about-index" */ '@/pages/about/index.vue'
  )
}
function admin_index() {
  return import(
    /* webpackChunkName: "page-admin-index" */ '@/pages/admin/index.vue'
  )
}
function browse_courses_index() {
  return import(
    /* webpackChunkName: "page-browse-courses-index" */ '@/pages/browse-courses/index.vue'
  )
}
function deal_store_index() {
  return import(
    /* webpackChunkName: "page-deal-store-index" */ '@/pages/deal-store/index.vue'
  )
}
function glossary_index() {
  return import(
    /* webpackChunkName: "page-glossary-index" */ '@/pages/glossary/index.vue'
  )
}
function my_courses_index() {
  return import(
    /* webpackChunkName: "page-my-courses-index" */ '@/pages/my-courses/index.vue'
  )
}
function my_deals_index() {
  return import(
    /* webpackChunkName: "page-my-deals-index" */ '@/pages/my-deals/index.vue'
  )
}
function my_profile_index() {
  return import(
    /* webpackChunkName: "page-my-profile-index" */ '@/pages/my-profile/index.vue'
  )
}
function teaching_index() {
  return import(
    /* webpackChunkName: "page-teaching-index" */ '@/pages/teaching/index.vue'
  )
}
function admin_courses_index() {
  return import(
    /* webpackChunkName: "page-admin-courses-index" */ '@/pages/admin/courses/index.vue'
  )
}
function admin_deal_packs_index() {
  return import(
    /* webpackChunkName: "page-admin-deal-packs-index" */ '@/pages/admin/deal-packs/index.vue'
  )
}
function admin_focuses_index() {
  return import(
    /* webpackChunkName: "page-admin-focuses-index" */ '@/pages/admin/focuses/index.vue'
  )
}
function admin_keywords_index() {
  return import(
    /* webpackChunkName: "page-admin-keywords-index" */ '@/pages/admin/keywords/index.vue'
  )
}
function admin_knowledgebase_index() {
  return import(
    /* webpackChunkName: "page-admin-knowledgebase-index" */ '@/pages/admin/knowledgebase/index.vue'
  )
}
function admin_queue_index() {
  return import(
    /* webpackChunkName: "page-admin-queue-index" */ '@/pages/admin/queue/index.vue'
  )
}
function admin_users_index() {
  return import(
    /* webpackChunkName: "page-admin-users-index" */ '@/pages/admin/users/index.vue'
  )
}
function browse_courses_checkout_cancelled() {
  return import(
    /* webpackChunkName: "page-browse-courses-checkout-cancelled" */ '@/pages/browse-courses/checkout-cancelled.vue'
  )
}
function browse_courses_checkout_complete() {
  return import(
    /* webpackChunkName: "page-browse-courses-checkout-complete" */ '@/pages/browse-courses/checkout-complete.vue'
  )
}
function deal_store_checkout_cancelled() {
  return import(
    /* webpackChunkName: "page-deal-store-checkout-cancelled" */ '@/pages/deal-store/checkout-cancelled.vue'
  )
}
function deal_store_checkout_complete() {
  return import(
    /* webpackChunkName: "page-deal-store-checkout-complete" */ '@/pages/deal-store/checkout-complete.vue'
  )
}
function my_profile_change_email() {
  return import(
    /* webpackChunkName: "page-my-profile-change-email" */ '@/pages/my-profile/change-email.vue'
  )
}
function my_profile_change_password() {
  return import(
    /* webpackChunkName: "page-my-profile-change-password" */ '@/pages/my-profile/change-password.vue'
  )
}
function teaching_courses_index() {
  return import(
    /* webpackChunkName: "page-teaching-courses-index" */ '@/pages/teaching/courses/index.vue'
  )
}
function teaching_deal_packs_index() {
  return import(
    /* webpackChunkName: "page-teaching-deal-packs-index" */ '@/pages/teaching/deal-packs/index.vue'
  )
}
function teaching_deals_index() {
  return import(
    /* webpackChunkName: "page-teaching-deals-index" */ '@/pages/teaching/deals/index.vue'
  )
}
function teaching_links_index() {
  return import(
    /* webpackChunkName: "page-teaching-links-index" */ '@/pages/teaching/links/index.vue'
  )
}
function teaching_options_index() {
  return import(
    /* webpackChunkName: "page-teaching-options-index" */ '@/pages/teaching/options/index.vue'
  )
}
function teaching_payment_index() {
  return import(
    /* webpackChunkName: "page-teaching-payment-index" */ '@/pages/teaching/payment/index.vue'
  )
}
function teaching_students_index() {
  return import(
    /* webpackChunkName: "page-teaching-students-index" */ '@/pages/teaching/students/index.vue'
  )
}
function teaching_transactions_index() {
  return import(
    /* webpackChunkName: "page-teaching-transactions-index" */ '@/pages/teaching/transactions/index.vue'
  )
}
function admin_focuses_create() {
  return import(
    /* webpackChunkName: "page-admin-focuses-create" */ '@/pages/admin/focuses/create.vue'
  )
}
function admin_keywords_create() {
  return import(
    /* webpackChunkName: "page-admin-keywords-create" */ '@/pages/admin/keywords/create.vue'
  )
}
function admin_knowledgebase_articles_index() {
  return import(
    /* webpackChunkName: "page-admin-knowledgebase-articles-index" */ '@/pages/admin/knowledgebase/articles/index.vue'
  )
}
function admin_knowledgebase_categories_index() {
  return import(
    /* webpackChunkName: "page-admin-knowledgebase-categories-index" */ '@/pages/admin/knowledgebase/categories/index.vue'
  )
}
function admin_queue_deal_packs() {
  return import(
    /* webpackChunkName: "page-admin-queue-deal-packs" */ '@/pages/admin/queue/deal-packs.vue'
  )
}
function teaching_courses_create() {
  return import(
    /* webpackChunkName: "page-teaching-courses-create" */ '@/pages/teaching/courses/create.vue'
  )
}
function teaching_deal_packs_create() {
  return import(
    /* webpackChunkName: "page-teaching-deal-packs-create" */ '@/pages/teaching/deal-packs/create.vue'
  )
}
function teaching_deals_create() {
  return import(
    /* webpackChunkName: "page-teaching-deals-create" */ '@/pages/teaching/deals/create.vue'
  )
}
function teaching_links_create() {
  return import(
    /* webpackChunkName: "page-teaching-links-create" */ '@/pages/teaching/links/create.vue'
  )
}
function admin_knowledgebase_articles_create() {
  return import(
    /* webpackChunkName: "page-admin-knowledgebase-articles-create" */ '@/pages/admin/knowledgebase/articles/create.vue'
  )
}
function admin_knowledgebase_categories_create() {
  return import(
    /* webpackChunkName: "page-admin-knowledgebase-categories-create" */ '@/pages/admin/knowledgebase/categories/create.vue'
  )
}
function admin_knowledgebase_articles__articleId() {
  return import(
    /* webpackChunkName: "page-admin-knowledgebase-articles-articleId" */ '@/pages/admin/knowledgebase/articles/_articleId.vue'
  )
}
function admin_knowledgebase_categories__categoryId() {
  return import(
    /* webpackChunkName: "page-admin-knowledgebase-categories-categoryId" */ '@/pages/admin/knowledgebase/categories/_categoryId.vue'
  )
}
function teaching_deals_groups__groupId() {
  return import(
    /* webpackChunkName: "page-teaching-deals-groups-groupId" */ '@/pages/teaching/deals/groups/_groupId.vue'
  )
}
function admin_courses__courseId_index() {
  return import(
    /* webpackChunkName: "page-admin-courses-courseId-index" */ '@/pages/admin/courses/_courseId/index.vue'
  )
}
function admin_deal_packs__dealPackId_index() {
  return import(
    /* webpackChunkName: "page-admin-deal-packs-dealPackId-index" */ '@/pages/admin/deal-packs/_dealPackId/index.vue'
  )
}
function admin_focuses__focusId_index() {
  return import(
    /* webpackChunkName: "page-admin-focuses-focusId-index" */ '@/pages/admin/focuses/_focusId/index.vue'
  )
}
function admin_keywords__keywordId_index() {
  return import(
    /* webpackChunkName: "page-admin-keywords-keywordId-index" */ '@/pages/admin/keywords/_keywordId/index.vue'
  )
}
function admin_teachers__profileId() {
  return import(
    /* webpackChunkName: "page-admin-teachers-profileId" */ '@/pages/admin/teachers/_profileId.vue'
  )
}
function admin_users__userId_index() {
  return import(
    /* webpackChunkName: "page-admin-users-userId-index" */ '@/pages/admin/users/_userId/index.vue'
  )
}
function teaching_courses__courseId_index() {
  return import(
    /* webpackChunkName: "page-teaching-courses-courseId-index" */ '@/pages/teaching/courses/_courseId/index.vue'
  )
}
function teaching_deal_packs__dealPackId_index() {
  return import(
    /* webpackChunkName: "page-teaching-deal-packs-dealPackId-index" */ '@/pages/teaching/deal-packs/_dealPackId/index.vue'
  )
}
function teaching_deals__dealId_index() {
  return import(
    /* webpackChunkName: "page-teaching-deals-dealId-index" */ '@/pages/teaching/deals/_dealId/index.vue'
  )
}
function teaching_links__linkId_index() {
  return import(
    /* webpackChunkName: "page-teaching-links-linkId-index" */ '@/pages/teaching/links/_linkId/index.vue'
  )
}
function teaching_students__studentId() {
  return import(
    /* webpackChunkName: "page-teaching-students-studentId" */ '@/pages/teaching/students/_studentId.vue'
  )
}
function admin_courses__courseId_edit() {
  return import(
    /* webpackChunkName: "page-admin-courses-courseId-edit" */ '@/pages/admin/courses/_courseId/edit.vue'
  )
}
function admin_courses__courseId_students_index() {
  return import(
    /* webpackChunkName: "page-admin-courses-courseId-students-index" */ '@/pages/admin/courses/_courseId/students/index.vue'
  )
}
function admin_deal_packs__dealPackId_edit() {
  return import(
    /* webpackChunkName: "page-admin-deal-packs-dealPackId-edit" */ '@/pages/admin/deal-packs/_dealPackId/edit.vue'
  )
}
function admin_deal_packs__dealPackId_students_index() {
  return import(
    /* webpackChunkName: "page-admin-deal-packs-dealPackId-students-index" */ '@/pages/admin/deal-packs/_dealPackId/students/index.vue'
  )
}
function admin_users__userId_edit() {
  return import(
    /* webpackChunkName: "page-admin-users-userId-edit" */ '@/pages/admin/users/_userId/edit.vue'
  )
}
function admin_users__userId_commission_index() {
  return import(
    /* webpackChunkName: "page-admin-users-userId-commission-index" */ '@/pages/admin/users/_userId/commission/index.vue'
  )
}
function admin_users__userId_purchases_index() {
  return import(
    /* webpackChunkName: "page-admin-users-userId-purchases-index" */ '@/pages/admin/users/_userId/purchases/index.vue'
  )
}
function admin_users__userId_sales_index() {
  return import(
    /* webpackChunkName: "page-admin-users-userId-sales-index" */ '@/pages/admin/users/_userId/sales/index.vue'
  )
}
function admin_users__userId_transactions_index() {
  return import(
    /* webpackChunkName: "page-admin-users-userId-transactions-index" */ '@/pages/admin/users/_userId/transactions/index.vue'
  )
}
function teaching_courses__courseId_edit() {
  return import(
    /* webpackChunkName: "page-teaching-courses-courseId-edit" */ '@/pages/teaching/courses/_courseId/edit.vue'
  )
}
function teaching_courses__courseId_students_index() {
  return import(
    /* webpackChunkName: "page-teaching-courses-courseId-students-index" */ '@/pages/teaching/courses/_courseId/students/index.vue'
  )
}
function teaching_deal_packs__dealPackId_deals() {
  return import(
    /* webpackChunkName: "page-teaching-deal-packs-dealPackId-deals" */ '@/pages/teaching/deal-packs/_dealPackId/deals.vue'
  )
}
function teaching_deal_packs__dealPackId_edit() {
  return import(
    /* webpackChunkName: "page-teaching-deal-packs-dealPackId-edit" */ '@/pages/teaching/deal-packs/_dealPackId/edit.vue'
  )
}
function teaching_deal_packs__dealPackId_students_index() {
  return import(
    /* webpackChunkName: "page-teaching-deal-packs-dealPackId-students-index" */ '@/pages/teaching/deal-packs/_dealPackId/students/index.vue'
  )
}
function teaching_deals__dealId_edit() {
  return import(
    /* webpackChunkName: "page-teaching-deals-dealId-edit" */ '@/pages/teaching/deals/_dealId/edit.vue'
  )
}
function teaching_links__linkId_deals() {
  return import(
    /* webpackChunkName: "page-teaching-links-linkId-deals" */ '@/pages/teaching/links/_linkId/deals.vue'
  )
}
function teaching_courses__courseId_lessons_create() {
  return import(
    /* webpackChunkName: "page-teaching-courses-courseId-lessons-create" */ '@/pages/teaching/courses/_courseId/lessons/create.vue'
  )
}
function admin_courses__courseId_students__studentId() {
  return import(
    /* webpackChunkName: "page-admin-courses-courseId-students-studentId" */ '@/pages/admin/courses/_courseId/students/_studentId.vue'
  )
}
function admin_courses__courseId_lessons__lessonId_index() {
  return import(
    /* webpackChunkName: "page-admin-courses-courseId-lessons-lessonId-index" */ '@/pages/admin/courses/_courseId/lessons/_lessonId/index.vue'
  )
}
function admin_deal_packs__dealPackId_students__studentId() {
  return import(
    /* webpackChunkName: "page-admin-deal-packs-dealPackId-students-studentId" */ '@/pages/admin/deal-packs/_dealPackId/students/_studentId.vue'
  )
}
function admin_users__userId_purchases__enrolmentId() {
  return import(
    /* webpackChunkName: "page-admin-users-userId-purchases-enrolmentId" */ '@/pages/admin/users/_userId/purchases/_enrolmentId.vue'
  )
}
function admin_users__userId_sales__enrolmentId() {
  return import(
    /* webpackChunkName: "page-admin-users-userId-sales-enrolmentId" */ '@/pages/admin/users/_userId/sales/_enrolmentId.vue'
  )
}
function teaching_courses__courseId_lessons__lessonId_index() {
  return import(
    /* webpackChunkName: "page-teaching-courses-courseId-lessons-lessonId-index" */ '@/pages/teaching/courses/_courseId/lessons/_lessonId/index.vue'
  )
}
function teaching_courses__courseId_students__studentId() {
  return import(
    /* webpackChunkName: "page-teaching-courses-courseId-students-studentId" */ '@/pages/teaching/courses/_courseId/students/_studentId.vue'
  )
}
function teaching_deal_packs__dealPackId_students__studentId() {
  return import(
    /* webpackChunkName: "page-teaching-deal-packs-dealPackId-students-studentId" */ '@/pages/teaching/deal-packs/_dealPackId/students/_studentId.vue'
  )
}
function admin_courses__courseId_lessons__lessonId_edit() {
  return import(
    /* webpackChunkName: "page-admin-courses-courseId-lessons-lessonId-edit" */ '@/pages/admin/courses/_courseId/lessons/_lessonId/edit.vue'
  )
}
function teaching_courses__courseId_lessons__lessonId_deals() {
  return import(
    /* webpackChunkName: "page-teaching-courses-courseId-lessons-lessonId-deals" */ '@/pages/teaching/courses/_courseId/lessons/_lessonId/deals.vue'
  )
}
function teaching_courses__courseId_lessons__lessonId_edit() {
  return import(
    /* webpackChunkName: "page-teaching-courses-courseId-lessons-lessonId-edit" */ '@/pages/teaching/courses/_courseId/lessons/_lessonId/edit.vue'
  )
}
function teaching_courses__courseId_lessons__lessonId_activities_create() {
  return import(
    /* webpackChunkName: "page-teaching-courses-courseId-lessons-lessonId-activities-create" */ '@/pages/teaching/courses/_courseId/lessons/_lessonId/activities/create.vue'
  )
}
function admin_courses__courseId_lessons__lessonId_activities__activityId_index() {
  return import(
    /* webpackChunkName: "page-admin-courses-courseId-lessons-lessonId-activities-activityId-index" */ '@/pages/admin/courses/_courseId/lessons/_lessonId/activities/_activityId/index.vue'
  )
}
function teaching_courses__courseId_lessons__lessonId_activities__activityId_index() {
  return import(
    /* webpackChunkName: "page-teaching-courses-courseId-lessons-lessonId-activities-activityId-index" */ '@/pages/teaching/courses/_courseId/lessons/_lessonId/activities/_activityId/index.vue'
  )
}
function admin_courses__courseId_lessons__lessonId_activities__activityId_edit() {
  return import(
    /* webpackChunkName: "page-admin-courses-courseId-lessons-lessonId-activities-activityId-edit" */ '@/pages/admin/courses/_courseId/lessons/_lessonId/activities/_activityId/edit.vue'
  )
}
function admin_courses__courseId_lessons__lessonId_activities__activityId_view() {
  return import(
    /* webpackChunkName: "page-admin-courses-courseId-lessons-lessonId-activities-activityId-view" */ '@/pages/admin/courses/_courseId/lessons/_lessonId/activities/_activityId/view.vue'
  )
}
function teaching_courses__courseId_lessons__lessonId_activities__activityId_edit() {
  return import(
    /* webpackChunkName: "page-teaching-courses-courseId-lessons-lessonId-activities-activityId-edit" */ '@/pages/teaching/courses/_courseId/lessons/_lessonId/activities/_activityId/edit.vue'
  )
}
function teaching_courses__courseId_lessons__lessonId_activities__activityId_view() {
  return import(
    /* webpackChunkName: "page-teaching-courses-courseId-lessons-lessonId-activities-activityId-view" */ '@/pages/teaching/courses/_courseId/lessons/_lessonId/activities/_activityId/view.vue'
  )
}
function about__categorySlug_index() {
  return import(
    /* webpackChunkName: "page-about-categorySlug-index" */ '@/pages/about/_categorySlug/index.vue'
  )
}
function browse_courses__courseId_index() {
  return import(
    /* webpackChunkName: "page-browse-courses-courseId-index" */ '@/pages/browse-courses/_courseId/index.vue'
  )
}
function deal_store__dealPackId_index() {
  return import(
    /* webpackChunkName: "page-deal-store-dealPackId-index" */ '@/pages/deal-store/_dealPackId/index.vue'
  )
}
function my_courses__courseId_index() {
  return import(
    /* webpackChunkName: "page-my-courses-courseId-index" */ '@/pages/my-courses/_courseId/index.vue'
  )
}
function my_deals__dealPackId_index() {
  return import(
    /* webpackChunkName: "page-my-deals-dealPackId-index" */ '@/pages/my-deals/_dealPackId/index.vue'
  )
}
function teachers__profileId() {
  return import(
    /* webpackChunkName: "page-teachers-profileId" */ '@/pages/teachers/_profileId.vue'
  )
}
function my_courses__courseId_lessons__lessonId_index() {
  return import(
    /* webpackChunkName: "page-my-courses-courseId-lessons-lessonId-index" */ '@/pages/my-courses/_courseId/lessons/_lessonId/index.vue'
  )
}
function my_courses__courseId_lessons__lessonId_activities__activityId() {
  return import(
    /* webpackChunkName: "page-my-courses-courseId-lessons-lessonId-activities-activityId" */ '@/pages/my-courses/_courseId/lessons/_lessonId/activities/_activityId.vue'
  )
}
function about__categorySlug__articleSlug() {
  return import(
    /* webpackChunkName: "page-about-categorySlug-articleSlug" */ '@/pages/about/_categorySlug/_articleSlug.vue'
  )
}

export default [
  {
    name: 'index',
    path: '',
    component: index,
    meta: {
      isPublic: true,
    },
  },
  {
    name: '404',
    path: '404',
    component: _404,
  },
  {
    name: 'create-account',
    path: 'create-account',
    component: create_account,
    meta: {
      isPublicOnly: true,
    },
  },
  {
    name: 'login',
    path: 'login',
    component: login,
    meta: {
      isPublicOnly: true,
    },
  },
  {
    name: 'new-password',
    path: 'new-password',
    component: new_password,
    meta: {
      isPublic: true,
    },
  },
  {
    name: 'reset-password',
    path: 'reset-password',
    component: reset_password,
    meta: {
      isPublicOnly: true,
    },
  },
  {
    name: 'setup-profile',
    path: 'setup-profile',
    component: setup_profile,
  },
  {
    name: 'simulator-remote',
    path: 'simulator-remote',
    component: simulator_remote,
  },
  {
    name: 'about',
    path: 'about',
    component: about_index,
    meta: {
      isPublic: true,
    },
  },
  {
    name: 'admin',
    path: 'admin',
    component: admin_index,
    meta: {
      isAdminOnly: true,
    },
  },
  {
    name: 'browse-courses',
    path: 'browse-courses',
    component: browse_courses_index,
    meta: {
      isPublic: true,
    },
  },
  {
    name: 'deal-store',
    path: 'deal-store',
    component: deal_store_index,
    meta: {
      isPublic: true,
    },
  },
  {
    name: 'glossary',
    path: 'glossary',
    component: glossary_index,
    meta: {
      isPublic: true,
    },
  },
  {
    name: 'my-courses',
    path: 'my-courses',
    component: my_courses_index,
    meta: {
      showTopPicks: true,
    },
  },
  {
    name: 'my-deals',
    path: 'my-deals',
    component: my_deals_index,
    meta: {
      showTopPicks: true,
    },
  },
  {
    name: 'my-profile',
    path: 'my-profile',
    component: my_profile_index,
  },
  {
    name: 'teaching',
    path: 'teaching',
    component: teaching_index,
    meta: {
      isTeacherOnly: true,
    },
  },
  {
    name: 'admin-courses',
    path: 'admin/courses',
    component: admin_courses_index,
  },
  {
    name: 'admin-deal-packs',
    path: 'admin/deal-packs',
    component: admin_deal_packs_index,
    meta: {
      isAdminOnly: true,
    },
  },
  {
    name: 'admin-focuses',
    path: 'admin/focuses',
    component: admin_focuses_index,
  },
  {
    name: 'admin-keywords',
    path: 'admin/keywords',
    component: admin_keywords_index,
  },
  {
    name: 'admin-knowledgebase',
    path: 'admin/knowledgebase',
    component: admin_knowledgebase_index,
    meta: {
      isAdminOnly: true,
    },
  },
  {
    name: 'admin-queue',
    path: 'admin/queue',
    component: admin_queue_index,
  },
  {
    name: 'admin-users',
    path: 'admin/users',
    component: admin_users_index,
  },
  {
    name: 'browse-courses-checkout-cancelled',
    path: 'browse-courses/checkout-cancelled',
    component: browse_courses_checkout_cancelled,
  },
  {
    name: 'browse-courses-checkout-complete',
    path: 'browse-courses/checkout-complete',
    component: browse_courses_checkout_complete,
  },
  {
    name: 'deal-store-checkout-cancelled',
    path: 'deal-store/checkout-cancelled',
    component: deal_store_checkout_cancelled,
  },
  {
    name: 'deal-store-checkout-complete',
    path: 'deal-store/checkout-complete',
    component: deal_store_checkout_complete,
  },
  {
    name: 'my-profile-change-email',
    path: 'my-profile/change-email',
    component: my_profile_change_email,
  },
  {
    name: 'my-profile-change-password',
    path: 'my-profile/change-password',
    component: my_profile_change_password,
  },
  {
    name: 'teaching-courses',
    path: 'teaching/courses',
    component: teaching_courses_index,
  },
  {
    name: 'teaching-deal-packs',
    path: 'teaching/deal-packs',
    component: teaching_deal_packs_index,
    meta: {
      isPublic: true,
    },
  },
  {
    name: 'teaching-deals',
    path: 'teaching/deals',
    component: teaching_deals_index,
  },
  {
    name: 'teaching-links',
    path: 'teaching/links',
    component: teaching_links_index,
  },
  {
    name: 'teaching-options',
    path: 'teaching/options',
    component: teaching_options_index,
    meta: {
      isTeacherOnly: true,
    },
  },
  {
    name: 'teaching-payment',
    path: 'teaching/payment',
    component: teaching_payment_index,
    meta: {
      isTeacherOnly: true,
    },
  },
  {
    name: 'teaching-students',
    path: 'teaching/students',
    component: teaching_students_index,
  },
  {
    name: 'teaching-transactions',
    path: 'teaching/transactions',
    component: teaching_transactions_index,
    meta: {
      isTeacherOnly: true,
    },
  },
  {
    name: 'admin-focuses-create',
    path: 'admin/focuses/create',
    component: admin_focuses_create,
  },
  {
    name: 'admin-keywords-create',
    path: 'admin/keywords/create',
    component: admin_keywords_create,
  },
  {
    name: 'admin-knowledgebase-articles',
    path: 'admin/knowledgebase/articles',
    component: admin_knowledgebase_articles_index,
  },
  {
    name: 'admin-knowledgebase-categories',
    path: 'admin/knowledgebase/categories',
    component: admin_knowledgebase_categories_index,
  },
  {
    name: 'admin-queue-deal-packs',
    path: 'admin/queue/deal-packs',
    component: admin_queue_deal_packs,
  },
  {
    name: 'teaching-courses-create',
    path: 'teaching/courses/create',
    component: teaching_courses_create,
  },
  {
    name: 'teaching-deal-packs-create',
    path: 'teaching/deal-packs/create',
    component: teaching_deal_packs_create,
  },
  {
    name: 'teaching-deals-create',
    path: 'teaching/deals/create',
    component: teaching_deals_create,
  },
  {
    name: 'teaching-links-create',
    path: 'teaching/links/create',
    component: teaching_links_create,
  },
  {
    name: 'admin-knowledgebase-articles-create',
    path: 'admin/knowledgebase/articles/create',
    component: admin_knowledgebase_articles_create,
  },
  {
    name: 'admin-knowledgebase-categories-create',
    path: 'admin/knowledgebase/categories/create',
    component: admin_knowledgebase_categories_create,
  },
  {
    name: 'admin-knowledgebase-articles-articleId',
    path: 'admin/knowledgebase/articles/:articleId?',
    component: admin_knowledgebase_articles__articleId,
  },
  {
    name: 'admin-knowledgebase-categories-categoryId',
    path: 'admin/knowledgebase/categories/:categoryId?',
    component: admin_knowledgebase_categories__categoryId,
  },
  {
    name: 'teaching-deals-groups-groupId',
    path: 'teaching/deals/groups/:groupId?',
    component: teaching_deals_groups__groupId,
  },
  {
    name: 'admin-courses-courseId',
    path: 'admin/courses/:courseId',
    component: admin_courses__courseId_index,
    meta: {
      isAdminOnly: true,
    },
  },
  {
    name: 'admin-deal-packs-dealPackId',
    path: 'admin/deal-packs/:dealPackId',
    component: admin_deal_packs__dealPackId_index,
    meta: {
      isAdminOnly: true,
    },
  },
  {
    name: 'admin-focuses-focusId',
    path: 'admin/focuses/:focusId',
    component: admin_focuses__focusId_index,
  },
  {
    name: 'admin-keywords-keywordId',
    path: 'admin/keywords/:keywordId',
    component: admin_keywords__keywordId_index,
  },
  {
    name: 'admin-teachers-profileId',
    path: 'admin/teachers/:profileId?',
    component: admin_teachers__profileId,
  },
  {
    name: 'admin-users-userId',
    path: 'admin/users/:userId',
    component: admin_users__userId_index,
  },
  {
    name: 'teaching-courses-courseId',
    path: 'teaching/courses/:courseId',
    component: teaching_courses__courseId_index,
  },
  {
    name: 'teaching-deal-packs-dealPackId',
    path: 'teaching/deal-packs/:dealPackId',
    component: teaching_deal_packs__dealPackId_index,
  },
  {
    name: 'teaching-deals-dealId',
    path: 'teaching/deals/:dealId',
    component: teaching_deals__dealId_index,
  },
  {
    name: 'teaching-links-linkId',
    path: 'teaching/links/:linkId',
    component: teaching_links__linkId_index,
  },
  {
    name: 'teaching-students-studentId',
    path: 'teaching/students/:studentId?',
    component: teaching_students__studentId,
  },
  {
    name: 'admin-courses-courseId-edit',
    path: 'admin/courses/:courseId/edit',
    component: admin_courses__courseId_edit,
    meta: {
      isAdminOnly: true,
    },
  },
  {
    name: 'admin-courses-courseId-students',
    path: 'admin/courses/:courseId/students',
    component: admin_courses__courseId_students_index,
  },
  {
    name: 'admin-deal-packs-dealPackId-edit',
    path: 'admin/deal-packs/:dealPackId/edit',
    component: admin_deal_packs__dealPackId_edit,
    meta: {
      isAdminOnly: true,
    },
  },
  {
    name: 'admin-deal-packs-dealPackId-students',
    path: 'admin/deal-packs/:dealPackId/students',
    component: admin_deal_packs__dealPackId_students_index,
  },
  {
    name: 'admin-users-userId-edit',
    path: 'admin/users/:userId/edit',
    component: admin_users__userId_edit,
  },
  {
    name: 'admin-users-userId-commission',
    path: 'admin/users/:userId/commission',
    component: admin_users__userId_commission_index,
  },
  {
    name: 'admin-users-userId-purchases',
    path: 'admin/users/:userId/purchases',
    component: admin_users__userId_purchases_index,
  },
  {
    name: 'admin-users-userId-sales',
    path: 'admin/users/:userId/sales',
    component: admin_users__userId_sales_index,
  },
  {
    name: 'admin-users-userId-transactions',
    path: 'admin/users/:userId/transactions',
    component: admin_users__userId_transactions_index,
  },
  {
    name: 'teaching-courses-courseId-edit',
    path: 'teaching/courses/:courseId/edit',
    component: teaching_courses__courseId_edit,
  },
  {
    name: 'teaching-courses-courseId-students',
    path: 'teaching/courses/:courseId/students',
    component: teaching_courses__courseId_students_index,
  },
  {
    name: 'teaching-deal-packs-dealPackId-deals',
    path: 'teaching/deal-packs/:dealPackId/deals',
    component: teaching_deal_packs__dealPackId_deals,
  },
  {
    name: 'teaching-deal-packs-dealPackId-edit',
    path: 'teaching/deal-packs/:dealPackId/edit',
    component: teaching_deal_packs__dealPackId_edit,
  },
  {
    name: 'teaching-deal-packs-dealPackId-students',
    path: 'teaching/deal-packs/:dealPackId/students',
    component: teaching_deal_packs__dealPackId_students_index,
  },
  {
    name: 'teaching-deals-dealId-edit',
    path: 'teaching/deals/:dealId/edit',
    component: teaching_deals__dealId_edit,
  },
  {
    name: 'teaching-links-linkId-deals',
    path: 'teaching/links/:linkId/deals',
    component: teaching_links__linkId_deals,
  },
  {
    name: 'teaching-courses-courseId-lessons-create',
    path: 'teaching/courses/:courseId/lessons/create',
    component: teaching_courses__courseId_lessons_create,
  },
  {
    name: 'admin-courses-courseId-students-studentId',
    path: 'admin/courses/:courseId/students/:studentId?',
    component: admin_courses__courseId_students__studentId,
  },
  {
    name: 'admin-courses-courseId-lessons-lessonId',
    path: 'admin/courses/:courseId/lessons/:lessonId',
    component: admin_courses__courseId_lessons__lessonId_index,
  },
  {
    name: 'admin-deal-packs-dealPackId-students-studentId',
    path: 'admin/deal-packs/:dealPackId/students/:studentId?',
    component: admin_deal_packs__dealPackId_students__studentId,
  },
  {
    name: 'admin-users-userId-purchases-enrolmentId',
    path: 'admin/users/:userId/purchases/:enrolmentId?',
    component: admin_users__userId_purchases__enrolmentId,
  },
  {
    name: 'admin-users-userId-sales-enrolmentId',
    path: 'admin/users/:userId/sales/:enrolmentId?',
    component: admin_users__userId_sales__enrolmentId,
  },
  {
    name: 'teaching-courses-courseId-lessons-lessonId',
    path: 'teaching/courses/:courseId/lessons/:lessonId',
    component: teaching_courses__courseId_lessons__lessonId_index,
  },
  {
    name: 'teaching-courses-courseId-students-studentId',
    path: 'teaching/courses/:courseId/students/:studentId?',
    component: teaching_courses__courseId_students__studentId,
  },
  {
    name: 'teaching-deal-packs-dealPackId-students-studentId',
    path: 'teaching/deal-packs/:dealPackId/students/:studentId?',
    component: teaching_deal_packs__dealPackId_students__studentId,
  },
  {
    name: 'admin-courses-courseId-lessons-lessonId-edit',
    path: 'admin/courses/:courseId/lessons/:lessonId/edit',
    component: admin_courses__courseId_lessons__lessonId_edit,
  },
  {
    name: 'teaching-courses-courseId-lessons-lessonId-deals',
    path: 'teaching/courses/:courseId/lessons/:lessonId/deals',
    component: teaching_courses__courseId_lessons__lessonId_deals,
  },
  {
    name: 'teaching-courses-courseId-lessons-lessonId-edit',
    path: 'teaching/courses/:courseId/lessons/:lessonId/edit',
    component: teaching_courses__courseId_lessons__lessonId_edit,
  },
  {
    name: 'teaching-courses-courseId-lessons-lessonId-activities-create',
    path: 'teaching/courses/:courseId/lessons/:lessonId/activities/create',
    component: teaching_courses__courseId_lessons__lessonId_activities_create,
  },
  {
    name: 'admin-courses-courseId-lessons-lessonId-activities-activityId',
    path: 'admin/courses/:courseId/lessons/:lessonId/activities/:activityId',
    component: admin_courses__courseId_lessons__lessonId_activities__activityId_index,
  },
  {
    name: 'teaching-courses-courseId-lessons-lessonId-activities-activityId',
    path: 'teaching/courses/:courseId/lessons/:lessonId/activities/:activityId',
    component: teaching_courses__courseId_lessons__lessonId_activities__activityId_index,
  },
  {
    name: 'admin-courses-courseId-lessons-lessonId-activities-activityId-edit',
    path:
      'admin/courses/:courseId/lessons/:lessonId/activities/:activityId/edit',
    component: admin_courses__courseId_lessons__lessonId_activities__activityId_edit,
  },
  {
    name: 'admin-courses-courseId-lessons-lessonId-activities-activityId-view',
    path:
      'admin/courses/:courseId/lessons/:lessonId/activities/:activityId/view',
    component: admin_courses__courseId_lessons__lessonId_activities__activityId_view,
  },
  {
    name:
      'teaching-courses-courseId-lessons-lessonId-activities-activityId-edit',
    path:
      'teaching/courses/:courseId/lessons/:lessonId/activities/:activityId/edit',
    component: teaching_courses__courseId_lessons__lessonId_activities__activityId_edit,
  },
  {
    name:
      'teaching-courses-courseId-lessons-lessonId-activities-activityId-view',
    path:
      'teaching/courses/:courseId/lessons/:lessonId/activities/:activityId/view',
    component: teaching_courses__courseId_lessons__lessonId_activities__activityId_view,
  },
  {
    name: 'about-categorySlug',
    path: 'about/:categorySlug',
    component: about__categorySlug_index,
    meta: {
      isPublic: true,
    },
  },
  {
    name: 'browse-courses-courseId',
    path: 'browse-courses/:courseId',
    component: browse_courses__courseId_index,
    meta: {
      showTopPicks: true,
    },
  },
  {
    name: 'deal-store-dealPackId',
    path: 'deal-store/:dealPackId',
    component: deal_store__dealPackId_index,
    meta: {
      showTopPicks: true,
    },
  },
  {
    name: 'my-courses-courseId',
    path: 'my-courses/:courseId',
    component: my_courses__courseId_index,
  },
  {
    name: 'my-deals-dealPackId',
    path: 'my-deals/:dealPackId',
    component: my_deals__dealPackId_index,
  },
  {
    name: 'teachers-profileId',
    path: 'teachers/:profileId?',
    component: teachers__profileId,
  },
  {
    name: 'my-courses-courseId-lessons-lessonId',
    path: 'my-courses/:courseId/lessons/:lessonId',
    component: my_courses__courseId_lessons__lessonId_index,
  },
  {
    name: 'my-courses-courseId-lessons-lessonId-activities-activityId',
    path: 'my-courses/:courseId/lessons/:lessonId/activities/:activityId?',
    component: my_courses__courseId_lessons__lessonId_activities__activityId,
  },
  {
    name: 'about-categorySlug-articleSlug',
    path: 'about/:categorySlug/:articleSlug?',
    component: about__categorySlug__articleSlug,
    meta: {
      isPublic: true,
    },
  },
]
